import type { SpaEntry } from '@kernel/config/types.js'

/**
 * Builds the effective CORS origins by merging the env CORS_ORIGIN
 * with the `origin` values declared in `spas` entries.
 *
 * Returns a string if there is only one unique origin (backward-compatible
 * with the cors middleware), or an array if there are multiple.
 */
export function buildEffectiveCorsOrigins(
  envOrigin: string,
  spas?: SpaEntry[]
): string | string[] | boolean {
  const origins = new Set<string>()

  // Parse env CORS_ORIGIN (supports comma-separated values)
  for (const o of envOrigin.split(',')) {
    const trimmed = o.trim()
    if (trimmed) origins.add(trimmed)
  }

  // Add origins from SPA entries
  for (const spa of spas ?? []) {
    if (spa.origin?.trim()) origins.add(spa.origin.trim())
  }

  // No origins configured: prod blocks cross-origin (same-origin only), dev reflects any origin
  if (origins.size === 0) {
    return process.env['NODE_ENV'] === 'production' ? false : true
  }

  const arr = [...origins]
  return arr.length === 1 ? arr[0]! : arr
}
